import { deriveArtistBio } from './bioUtils';

interface SeoArtist {
  name?: string;
  genres?: string[];
  followers?: { total?: number };
  topTracks?: Array<{ name?: string }>;
}

export const truncateSeoDescription = (value?: string, maxLength = 180): string => {
  const clean = (value || '').replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
  if (clean.length <= maxLength) return clean;

  const clipped = clean.slice(0, maxLength - 1);
  return `${clipped.slice(0, clipped.lastIndexOf(' ') || clipped.length).trim()}…`;
};

export const getArtistSeoDescription = (artist?: SeoArtist | null): string => {
  if (!artist?.name) {
    return 'Explore songs, albums, videos, biography, and latest music releases.';
  }

  return truncateSeoDescription(deriveArtistBio(artist.name, artist), 180);
};

export const getArtistSeoKeywords = (artist?: SeoArtist | null, extra: string[] = []): string =>
  [artist?.name, ...extra, ...(artist?.genres || []), 'music', 'songs', 'albums', 'videos']
    .filter(Boolean)
    .join(', ');
